import { Component, Input } from '@angular/core';
import { ControlValueAccessorModel, getProvider } from '../../../Forms/models/control-value-accessor.model';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { messageSeverityEnum } from '../../../Misc/enums/message-severity.enum';
import { BrandColor } from '../../../../api/brandIdentity/models/brand-identity.api.model';
import { ColorChangeModel } from '../../../Forms/models/color-change.model';
import { ColorPickerSourceType } from '../../../Forms/enums/color-picker-source-types.enum';
@Component({
    selector: 'agpr-brand-colors',
    templateUrl: './brand-colors.component.html',
    styleUrls: ['./brand-colors.component.scss'],
    providers: [getProvider(BrandColorsComponent)],
    standalone: false
})
export class BrandColorsComponent extends ControlValueAccessorModel<BrandColor[]> {
    readonly buttonTypes = ButtonTypesEnum;
    readonly messageSeverity = messageSeverityEnum;

    @Input() public id: string = 'brandColors';
    @Input() public maxLimit: number = 10;
    @Input() public disabled: boolean = false;


    addColorPickerPopoverOpened = false;

    togglePreferredColor(color: BrandColor) {
        const favorite = !color.favorite;
        this.value.forEach((itm, idx) => {
            itm.favorite = false;
        });
        color.favorite = favorite;
        this.emitValue();
    }

    onColorChange({value, source}: ColorChangeModel) {
        if (source !== ColorPickerSourceType.HUE) {
            this.addColor(value);
            this.addColorPickerPopoverOpened = false;
        }
    }

    addColor(color: string, index?: number) {
        const newValue: BrandColor = {
            color,
            favorite: false
        };
        if (index || index === 0) {
            newValue.id = this.value[index].id;
            this.value.splice(index, 1, newValue);
        } else {
            this.value.push(newValue);
        }
        this.emitValue();
    }

    removeColor(index: number) {
        this.value.splice(index, 1);
        this.emitValue();
    }

    emitValue() {
        this.onModelChange(this.value);
        this.onModelTouched();
    }

    override writeValue(value: BrandColor[]) {
        this.value = value ?? [];
    }

    override setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
